import React, {useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import EncryptUtils from 'src/utils/EncryptUtils';
import {deleteUamUserdetails} from '@shared/services/service-handlers/PrivateService';
import LoadingButton from '@mui/lab/LoadingButton';

interface DeleteConfirmDialogProps {
  open: boolean;
  userInfo: any;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  userInfo,
  onClose,
  onConfirm
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      if (userInfo?.id) {
        const loadData = async () => {
          setIsLoading(true);
          setError(null);
          try {
            // 1. Prepare and Call REAL API for User Details
            const payload: any = {id: userInfo?.id};
            const tk = EncryptUtils.encryptedData(payload);
            const userResponse = await deleteUamUserdetails({tk});
            if (userResponse) {
              onConfirm();
            } else {
              setError('Failed to Delete user details.');
            }
          } catch (err) {
            setError('Failed to Delete user data. Please try again.');
            console.error(err);
          } finally {
            setIsLoading(false);
          }
        };

        await loadData();
        setIsDeleting(false);
      } else {
        setIsDeleting(false);
        setError(
          'Failed to Delete user data. userInfo is not valid Please try again.'
        );
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  return (
    <Dialog open={open}>
      <DialogTitle>Delete User</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete{' '}
          <strong>{userInfo?.full_name ?? ''}</strong>? The user will be removed
          from the system and lose all pod accesses immediately. This action
          cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{p: 2}}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <LoadingButton
          loading={isDeleting}
          onClick={handleDelete}
          color="error"
          variant="contained"
          autoFocus>
          Delete User
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
